module.exports = __webpack_public_path__ + "img/vc.903f8e2f.svg";